module.exports = __webpack_public_path__ + "static/media/Discovery_Screen.21462799.png";